<template>
  <div
    v-if="value && percentageLoaded > 0 && percentageLoaded < 100"
    class="download-progress-component"
  >
    <div class="level">
      <div class="level-left text">Downloading {{ name }}</div>
      <div class="level-right">&nbsp;</div>
    </div>
    <div class="bar-total">
      <div class="bar-loaded" :style="{ width: percentageLoaded + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadProgress',
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  computed: {
    percentageLoaded() {
      return this.value ? this.value.downloadPercentage : 0;
    },
    name() {
      return this.value ? this.value.fileName : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.download-progress-component {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  padding: 20px 40px;

  .level {
    margin-bottom: 2px;
  }
  .text {
    font-size: 1.2rem;
  }

  .bar-total {
    border-radius: $radius;
    background: $light-gray;
    height: 16px;
    overflow: hidden;
    max-width: 1536px;
    margin: auto;

    .bar-loaded {
      width: 0;
      height: 16px;
      background: $success;
    }
  }
}
</style>
